// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"fe08d75b","61":"9fcb330f","208":"841d2822","373":"2e58ccd9","389":"352be7eb","451":"a53c4e04","631":"d6c69791","779":"4403da05","787":"159bd9f3","952":"749d1499","969":"86a59b56"}[chunkId] + ".chunk.js";
};